import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _wrap_native_super } from "@swc/helpers/_/_wrap_native_super";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { isWindowUndefined } from "./server-side-rendering/isWindowUndefined";
/* eslint-disable @faire/no-local-storage */ /* eslint-disable @faire/one-exported-class-per-file */ var getLocalStorage = function() {
    try {
        if (isWindowUndefined()) {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @faire-web/no-restricted-globals
        return window.localStorage;
    } catch (_) {
        return undefined;
    }
};
var getSessionStorage = function() {
    try {
        if (isWindowUndefined()) {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @faire-web/no-restricted-globals
        return window.sessionStorage;
    } catch (_) {
        return undefined;
    }
};
export var Storage = /*#__PURE__*/ function() {
    "use strict";
    function Storage(dataStorage) {
        var _this = this;
        _class_call_check(this, Storage);
        this.dataStorage = dataStorage;
        this._fallbackCache = {};
        this.isStorageAvailable = function() {
            if (!_this.dataStorage) {
                return false;
            }
            var testKey = "test";
            try {
                _this.dataStorage.setItem(testKey, "test");
                _this.dataStorage.removeItem(testKey);
            } catch (_) {
                return false;
            }
            return true;
        };
        this.getItem = function(key) {
            if (_this.isStorageAvailable()) {
                var value = _this.dataStorage.getItem(key);
                if (typeof value === "string") {
                    return value;
                }
            }
            if (_this._fallbackCache[key] !== undefined) {
                return _this._fallbackCache[key];
            }
            return undefined;
        };
        this.setItem = function(key, value) {
            if (_this.isStorageAvailable()) {
                _this.dataStorage.setItem(key, value);
                return;
            }
            _this._fallbackCache[key] = value;
        };
        this.removeItem = function(key) {
            if (_this.isStorageAvailable()) {
                _this.dataStorage.removeItem(key);
                return;
            }
            delete _this._fallbackCache[key];
        };
        this.clear = function() {
            if (_this.isStorageAvailable()) {
                _this.dataStorage.clear();
                return;
            }
            _this._fallbackCache = {};
        };
    }
    _create_class(Storage, null, [
        {
            key: "local",
            get: function get() {
                return LocalStorage.get();
            }
        },
        {
            key: "session",
            get: function get() {
                return SessionStorage.get();
            }
        }
    ]);
    return Storage;
}();
export var LocalStorage = /*#__PURE__*/ function(Storage) {
    "use strict";
    _inherits(LocalStorage, Storage);
    function LocalStorage() {
        _class_call_check(this, LocalStorage);
        return _call_super(this, LocalStorage, [
            getLocalStorage()
        ]);
    }
    return LocalStorage;
}(_wrap_native_super(Storage));
LocalStorage.get = singletonGetter(LocalStorage);
export var SessionStorage = /*#__PURE__*/ function(Storage) {
    "use strict";
    _inherits(SessionStorage, Storage);
    function SessionStorage() {
        _class_call_check(this, SessionStorage);
        return _call_super(this, SessionStorage, [
            getSessionStorage()
        ]);
    }
    return SessionStorage;
}(_wrap_native_super(Storage));
SessionStorage.get = singletonGetter(SessionStorage);
/**
 * @deprecated Use Storage.local. This const is evaluated too early in a cypress context.
 */ export var StorageService = new LocalStorage();
